import { ApolloError } from '@apollo/client';

export function areAllErrorsFromNonCriticalNodes(allowedNodes: string = '', errors: ApolloError): boolean {
  if (!allowedNodes.trim()) {
    return false;
  }
  const allowedSet = new Set(allowedNodes?.split(',')?.map(node => node?.trim()));
  return errors?.graphQLErrors?.every(error => {
    if (!error?.path || error?.path?.length === 0) return false;
    return error?.path?.some(p => allowedSet?.has(p.toString()));
  });
}
